/* eslint-disable global-require */
import Vue from 'vue';
import 'promise-polyfill/src/polyfill';
import 'core-js';
import Modal from 'vue-js-modal';
import VueProgressiveImage from 'vue-progressive-image';
import VueMq from 'vue-mq';
import GlobalDirectives from '@/components/directives/GlobalDirectives';
import LineClamp from 'vue-line-clamp';
import 'vue-smooth-picker/dist/css/style.css';
import SmoothPicker from 'vue-smooth-picker';
import VueAnime from 'vue-animejs';
import VueTimers from 'vue-timers';
import VueScrollLock from 'vue-scroll-lock';
import { register } from 'register-service-worker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import App from './App';
import router from './router';
import store from './stores/index';
import AppConstants from './utils/AppConstants';
import Formatter from './utils/Formatter';
import AnalyticsService from './services/analytics.service';
import Layout from './utils/Layout';

Vue.use(Loading);
Vue.use(VueScrollLock);
Vue.use(VueTimers);
Vue.use(VueAnime);
Vue.use(LineClamp);
Vue.use(SmoothPicker);

Object.defineProperty(Vue.prototype, '$appConstants', {
	value: AppConstants,
});

Object.defineProperty(Vue.prototype, '$isSidebar', {
	get() {
		return this.$appConstants.layoutOptions.sidebar;
	},
});

Object.defineProperty(Vue.prototype, '$isMinimal', {
	get() {
		const appConstants = this.$appConstants;
		const checkout = appConstants && appConstants.checkout;
		const isMinimal = checkout && !!(+checkout.minimal);
		return isMinimal;
	},
});

Object.defineProperty(Vue.prototype, '$deliveryEnabled', {
	get() {
		const appConstants = this.$appConstants;
		const service = appConstants && appConstants.service;
		const delivery = service && service.delivery;
		const deliveryEnabled = delivery && !!(+delivery.enabled);
		return deliveryEnabled;
	},
});

Object.defineProperty(Vue.prototype, '$useItemImages', {
	get() {
		const appConstants = this.$appConstants;
		const itemSettings = appConstants && appConstants.items;
		return itemSettings && +itemSettings.useImages;
	},
});

Object.defineProperty(Vue.prototype, '$isMobile', {
	get() {
		return (this.$mq === 'mobile');
	},
});

Object.defineProperty(Vue.prototype, '$layouts', {
	value: Layout,
});

// Touchpoint Analytics
Object.defineProperty(Vue.prototype, '$tpa', {
	value: AnalyticsService,
});

Object.defineProperty(Vue.prototype, '$format', {
	value: Formatter,
});

if ('serviceWorker' in navigator) {
	register('static/js/serviceWorker.js', {
		ready() {},
		registered(registration) {},
		cached(registration) {},
		updatefound(registration) {},
		updated(registration) {},
		offline() {},
		error(error) {},
	});
}

Vue.config.productionTip = false;

const modalConfig = {
	dialog: true,
	dynamic: true,
	adaptive: true,
	reset: true,
	injectModalsContainer: true,
};

Vue.use(Modal, modalConfig);

Vue.use(VueMq, {
	breakpoints: {
		mobile: 1088,
		tablet: 1088,
		desktop: Infinity,
	},
});

Vue.use(VueProgressiveImage, {
	cache: false,
});

GlobalDirectives();

/* eslint-disable */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js